import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46cd6763"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:tw-w-[800px]" }
const _hoisted_2 = {
  key: 1,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[37px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_3 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }
const _hoisted_4 = {
  key: 2,
  class: "tw-mb-[25px] tw-pt-[37px] tw-leading-[100%]"
}
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-medium" }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass(['tw-flex tw-justify-between tw-items-center'])
}
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(['tw-text-[#211F58] tw-text-[14px] tw-font-semibold'])
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"font-weight":"400"} }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-bg-[#387DFF] tw-rounded-[50%]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#fff] tw-text-base tw-font-medium tw-mt-[2px]" }, "+")
], -1))

import Utils, { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import store from "@/store";
import { ComputedRef, computed, onBeforeUnmount, ref } from "vue";
import ListService from "./listService.vue";
import WizardMultiLevelMultiSelectQuestion from "./wizardMultiLevelMultiSelectQuestion.vue";
import {
  statusPage,
  WIZARD_STATE_NAME,
  WIZARD_STATE_PAGE,
} from "@/utils/constants";
import {
  IWizardQuestion,
  IWizardServicesValue,
  IWizardTypeValue,
} from "@/interfaces/wizard";
import { Ref } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";
import { onMounted } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import dayjs from "dayjs";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'servicesPage',
  props: {
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["change:add:service"],
  setup(__props, { expose: __expose, emit }) {





const listServicesRef: any = ref([]);
const timeUpdated: any = ref(`${dayjs().unix()}`);

const currentOrg = computed(() => store.state.Org.currentOrg);
const originServices: ComputedRef<IWizardServicesValue[]> = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.values;
});
let servicesAnswers: ComputedRef<IWizardServicesValue[][]> = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.formatData;
});

const listServiceType = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.types;
});

const serviceSubTypeDropdown: Ref<IMultiSelectDropdown[]> = ref([]);
let listServiceSubType: IWizardTypeValue[] = [];

onMounted(() => {
  if (
    Array.isArray(listServiceType.value) &&
    listServiceType.value.length > 0
  ) {
    listServiceSubType = listServiceType?.value[1].typeValues ?? [];
    serviceSubTypeDropdown.value = generateServiceSubtypeDropdown(
      originServices.value || [],
    );
  }
  EventEmitter.on(EmitterEvents.SERVICE_DELETE_ITEM, (data: any) => {
    if (servicesAnswers.value[data.indexGroup].length === 1) {
      //parentTitle
      const serviceSubTypeId =
        servicesAnswers.value[data.indexGroup][0].serviceSubTypeId;
      let indexServiceSubType, indexParentServiceSubType;
      if (!servicesAnswers.value[data.indexGroup][0].parentTitle) {
        indexServiceSubType = serviceSubTypeDropdown.value.findIndex(
          (i) =>
            i.id === servicesAnswers.value[data.indexGroup][0].serviceSubTypeId,
        );
        serviceSubTypeDropdown.value[indexServiceSubType].selected = false;
      } else {
        for (let i = 0; i < serviceSubTypeDropdown.value.length; i++) {
          const childData = serviceSubTypeDropdown.value[i].childData;
          if (childData && childData.length > 0) {
            const indexSubType = childData.findIndex(
              (j) =>
                j.id ===
                servicesAnswers.value[data.indexGroup][0].serviceSubTypeId,
            );
            if (indexSubType > -1) {
              indexParentServiceSubType = i;
              indexServiceSubType = indexSubType;
              break;
            }
          }
        }
        const childData =
          serviceSubTypeDropdown.value[indexParentServiceSubType].childData ||
          [];
        childData[indexServiceSubType].selected = false;
        serviceSubTypeDropdown.value[indexParentServiceSubType].childData =
          childData;
      }
      servicesAnswers.value.splice(data.indexGroup, 1);
      timeUpdated.value = `${dayjs().unix()}`;
    } else {
      servicesAnswers.value[data.indexGroup].splice(data.indexCurrent, 1);
    }
  });
  EventEmitter.on(EmitterEvents.SERVICE_UPDATE_ITEM, (data: any) => {
    const item = servicesAnswers.value[data.indexGroup][data.indexCurrent];
    servicesAnswers.value[data.indexGroup][data.indexCurrent] = {
      ...item,
      id: data.dataUpdate?.id,
      endDate: data.dataUpdate?.endDate,
      timeUpdated: `${dayjs().unix()}${item.indexUpdate}`,
    };
  });
});

onBeforeUnmount(() => {
  EventEmitter.off(EmitterEvents.SERVICE_DELETE_ITEM);
  EventEmitter.off(EmitterEvents.SERVICE_UPDATE_ITEM);
});

const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  for (let index = 0; index < listServicesRef.value.length; index++) {
    const test = await listServicesRef.value[index].saveChanges();
    if (!test.isValid) {
      isAllValid = false;
    }
    listServices.push(test.finalValue);
  }
  return isAllValid;
};

const questionSectionValue: ComputedRef<IWizardQuestion[]> = computed(() =>
  store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.SERVICES,
    currentOrg.value.id || null,
  ),
);

const updateServiceType = (value: any, data: Array<any>) => {
  if (!value) return;
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    currentOrg: currentOrg.value.id,
    isSelected: true,
    namePage: WIZARD_STATE_PAGE.SERVICES,
    isSelectedPage: "isSelectedServices",
  });
  const index = servicesAnswers.value.findIndex(
    (i) => i[0].serviceSubTypeId === value,
  );
  if (index > -1) {
    onDeleteSubServiceType(index);
  } else {
    onAddSubServiceType(value);
  }
};

const onAddSubServiceType = (value) => {
  let indexGroup = servicesAnswers.value.findIndex(
    (i) => i[0].serviceSubTypeId === value,
  );
  let serviceData;
  if (indexGroup === -1) {
    const serviceSubType = listServiceSubType.find((i) => i.id === value);
    const title = serviceSubType?.name || "";
    let parentTitle = "";
    if (serviceSubType?.parentId) {
      const parentServiceSubType = listServiceSubType.find(
        (i) => i.id === serviceSubType.parentId,
      );
      parentTitle = `${parentServiceSubType?.name || ""}`;
    }
    const serviceTypeOptions = listServiceType.value[0].typeValues.filter(
      (i) => i.serviceSubTypeId === value,
    );
    serviceData = {
      serviceTypeOptions: serviceTypeOptions,
      serviceSubTypeId: value,
      parentTitle: parentTitle,
      title: title,
    };
  } else {
    serviceData = {
      serviceTypeOptions: servicesAnswers[indexGroup][0].serviceTypeOptions,
      serviceSubTypeId: servicesAnswers[indexGroup][0].serviceSubTypeId,
      parentTitle: servicesAnswers[indexGroup][0].parentTitle,
      title: servicesAnswers[indexGroup][0].title,
    };
  }
  addService(serviceData, indexGroup);
};

const onDeleteSubServiceType = (index) => {
  const serviceTypes = servicesAnswers.value[index].filter(
    (i) => i.id !== null,
  );
  for (let i = 0; i < serviceTypes.length; i++) {
    const value = {
      id: serviceTypes[i].id,
      isArchived: true,
      updated: true,
    };
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value,
      indexUpdate: serviceTypes[i].indexUpdate,
      currentOrg: currentOrg.value.id,
    });
  }
  servicesAnswers.value.splice(index, 1);
};

const generateServiceSubtypeDropdown = (services: IWizardServicesValue[]) => {
  const serviceTypeSelected: string[] = [];
  if (services && services.length > 0) {
    services.forEach((i) => {
      if (!i?.isArchived) serviceTypeSelected.push(i.serviceTypeId || "");
    });
  }

  const serviceSubTypeSelected = serviceTypeSelected.map((i) =>
    getServiceSubTypeId(i),
  );

  // If have services => always have value "questionSectionValue".
  if (!questionSectionValue.value) return [];

  const subTypeConverted = Utils.convertDataFlatToTree(
    listServiceSubType as any[],
  );

  // Format list dropdown.
  return Object.values(subTypeConverted).map(
    (item: any) =>
      ({
        ...item,
        title: item?.name || "",
        selected: serviceSubTypeSelected.includes(item?.id),
        childData: item?.childData.map((child) => ({
          ...child,
          title: child.name,
          selected: serviceSubTypeSelected.includes(child?.id),
        })),
      }) as IMultiSelectDropdown,
  );
};

const getServiceSubTypeId = (serviceTypeId: string) => {
  const serviceTypes = listServiceType.value[0].typeValues;
  const serviceType = serviceTypes.find((i) => i.id === serviceTypeId);
  return serviceType?.serviceSubTypeId || "";
};

const generateSelectedItems = (items: IMultiSelectDropdown[]) => {
  return items.reduce((result: IMultiSelectDropdown[], item) => {
    if (item.selected) result.push({ ...item });

    if (item.childData) {
      const childItems = generateSelectedItems(item.childData);
      result.push(...childItems);
    }

    return result;
  }, []);
};
const addService = (serviceData, indexGroup) => {
  const newServiceType = {
    serviceTypeOptions: serviceData.serviceTypeOptions,
    serviceSubTypeId: serviceData.serviceSubTypeId,
    parentTitle: serviceData.parentTitle,
    title: serviceData.title,
    initServiceType: {},
    idUpdate: Math.random(),
  };
  if (indexGroup > -1) {
    servicesAnswers.value[indexGroup].push(newServiceType);
  } else {
    servicesAnswers.value.push([newServiceType]);
  }
};
__expose({
  checkAllValidations,
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WizardQuestion, {
      title: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-services-title-1',
        )
      ,
      description: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-services-description-1',
        )
      ,
      "has-why": false,
      "custom-padding-x": '25px'
    }, {
      default: _withCtx(() => [
        (serviceSubTypeDropdown.value && serviceSubTypeDropdown.value.length)
          ? (_openBlock(), _createBlock(WizardMultiLevelMultiSelectQuestion, {
              key: 0,
              title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-services-question-1',
          )
        ,
              required: false,
              "dropdown-data": serviceSubTypeDropdown.value,
              placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-select-services-1',
          )
        ,
              "search-placeholder": 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-services-question-placeholder-1',
          )
        ,
              "time-updated": timeUpdated.value,
              "onUpdate:modelValue": updateServiceType
            }, null, 8, ["title", "dropdown-data", "placeholder", "search-placeholder", "time-updated"]))
          : _createCommentVNode("", true),
        (
          __props.statusInPage.statusPage === _unref(statusPage).Error &&
          __props.statusInPage.errorMessage
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(WarningIcon, { color: "#F7553C" }),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: __props.statusInPage.errorMessage
                  ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                  : "",
              },
            )), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(servicesAnswers) && _unref(servicesAnswers).length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
            "app-menu-submenu-home-setup-wizard-service-note-1",
          )), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(servicesAnswers) && _unref(servicesAnswers).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesAnswers), (groupService, indexGroup) => {
                return (_openBlock(), _createElementBlock("div", { key: indexGroup }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupService, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${item?.idUpdate || item.id}`,
                      class: "tw-mb-[10px]"
                    }, [
                      _createVNode(ListService, {
                        ref_for: true,
                        ref_key: "listServicesRef",
                        ref: listServicesRef,
                        index: index,
                        "item-first": item,
                        "current-index": index,
                        "group-index": indexGroup,
                        "status-in-page": __props.statusInPage,
                        "question-section-value": questionSectionValue.value,
                        "current-org": currentOrg.value.id,
                        "onUpdate:service": 
                (data) => {
                  _unref(servicesAnswers)[indexGroup][index].orgServices =
                    data?.orgServices;
                  _unref(servicesAnswers)[indexGroup][index] = {
                    ...data,
                  };
                }
              
                      }, null, 8, ["index", "item-first", "current-index", "group-index", "status-in-page", "question-section-value", "current-org", "onUpdate:service"])
                    ]))
                  }), 128)),
                  (groupService && groupService.length > 0)
                    ? (_openBlock(), _createBlock(_component_b_button, {
                        key: 0,
                        variant: "",
                        class: _normalizeClass(`button-add-another tw-mb-[25px]  tw-bg-[#fff] tw-py-[15px] tw-px-[25px] tw-rounded-md tw-w-full`),
                        style: {"border-radius":"6px","border":"1px solid var(--UI-rule, #eff0f1)"},
                        onClick: ($event: any) => (addService(groupService[0] || {}, indexGroup))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                    "app-menu-submenu-home-setup-wizard-add-another-button-1",
                  )) + " ", 1),
                              (groupService[0]?.parentTitle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(groupService[0]?.parentTitle) + ": ", 1),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(groupService[0]?.title), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(groupService[0].title), 1))
                            ]),
                            _hoisted_12
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "description"])
  ]))
}
}

})